import {
  Box,
  Header,
  Table,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React from 'react';

import { useShipping } from './shippingProvider';

export default function CarrierTable({ onShipSelect = () => {} }) {
  const {
    rates,
    selectedRates, setSelectedRates,
  } = useShipping();

  return (
    <Table
      header={<Header>Select Carrier and Delivery Service</Header>}
      onSelectionChange={({ detail }) => {
        setSelectedRates(detail.selectedItems);
        if (detail.selectedItems?.[0]?.name) {
          onShipSelect(detail.selectedItems[0].name);
        }
      }}
      selectedItems={selectedRates}
      columnDefinitions={[
        {
          id: 'carrier',
          header: 'Carrier',
          cell: (item) => item.carrier,
          isRowHeader: true,
        },
        {
          id: 'service',
          header: 'Service Level',
          // eslint-disable-next-line react/no-unstable-nested-components
          cell: (item) => (
            <div>
              <div>{item.name}</div>
              <Box color="text-status-inactive" variant="small">{item.transit}</Box>
            </div>
          ),
        },
        {
          id: 'days',
          header: 'Transit Days',
          cell: (item) => item.delivery_days,
        },
        {
          id: 'cost',
          header: 'Cost',
          cell: (item) => `$${item.price}`,
        },
      ]}
      items={rates}
      selectionType="single"
      trackBy="id"
    />
  );
}
CarrierTable.propTypes = {
  onShipSelect: PropTypes.func,
};
